import FormBuilder from '@/ui-kit/components/form/entities/FormBuilder';
import { requiredFormValidator } from '@/ui-kit/components/form/validators';
import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';

export const MarketDataChartFormControlName = {
  ChartType: 'chartTypeValue',
  TransactionDate: 'transactionDate',
};

export const MARKET_DATA_CHART_FORM_DEFAULT_VALUE = {
  [MarketDataChartFormControlName.ChartType]: 'Average Sold Price',
  [MarketDataChartFormControlName.TransactionDate]: '',
};

class MarketDataFiltersFormBuilder extends FormBuilder {
  createChartTypeControl(validators) {
    return this.createControl(MarketDataChartFormControlName.ChartType, validators);
  }

  createTransactionDateControl(validators) {
    return this.createControl(MarketDataChartFormControlName.TransactionDate, validators);
  }
}

const createMarketDataChartForm = (defaultValue) => (
  new MarketDataFiltersFormBuilder({ ...MARKET_DATA_CHART_FORM_DEFAULT_VALUE, ...defaultValue })
    .createChartTypeControl([requiredFormValidator])
    .createTransactionDateControl([requiredFormValidator])
    .build([FormControlValidationStrategy.Change, FormControlValidationStrategy.Blur])
);

export default createMarketDataChartForm;
